import { Input, Select } from "antd";
import { useUserContext } from "../context/UserContext";

const dropdownMenuProps = {
  getPopupContainer: () => document.body,
  listHeight: 256,
  popupMatchSelectWidth: false,
  styles: { popup: { root: { zIndex: 2000 } } },
};

export default function DeviceIdInput({
  deviceId,
  setDeviceId,
  isInventory = false,
}) {
  const { deviceIds, inventoryDeviceIds } = useUserContext();
  const options = (isInventory ? inventoryDeviceIds : deviceIds).map((d) => ({
    value: d,
    label: d,
  }));

  return (
    <div className="flex flex-wrap  gap-2 sm:gap-3 justify-center items-center  px-2">
      <span className="whitespace-nowrap text-sm sm:text-base font-medium text-gray-700">Device ID:</span>
      {isInventory ? (
        <Input
          value={deviceId}
          onChange={(e) => {
            if (e.target.value.length > 12) return;
            setDeviceId(e.target.value);
          }}
          size="large"
          placeholder="Enter Device ID"
          className="w-full sm:w-auto max-w-xs"
        />
      ) : (
        <Select
          {...dropdownMenuProps}
          showSearch
          value={deviceId || undefined}
          placeholder="Select Device ID"
          onChange={setDeviceId}
          options={options}
          filterOption={(input, option) =>
            (option.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          size="large"
          className="w-full sm:w-auto max-w-xs"
          style={{ minWidth: 180 }}
        />
      )}
    </div>
  );
}
